<template>
  <div>
    <section
      class="pa-4 pr-1 pb-0">
      <v-row>
        <v-col 
          cols="12" 
          md="9"
          class="py-0">
          <v-row>
            <v-col 
              cols="12" 
              md="4">
              <v-skeleton-loader
                v-for="(item, index) in process.load ? 1 : 1"
                :key="index"
                class="ma-auto"
                :loading="process.load"
                type="image">
                <div>
                  <v-card v-if="!process.load && Object.keys(count).length > 0"
                    flat
                    min-height="175"
                    class="border-radius"
                    color="#FFFFFF">
                    <v-card-text>
                      <div
                        class="d-flex align-start">
                        <div>
                          <div class="body-1 black--text font-weight-bold">
                            Total Abdi Dalem
                          </div>

                          <div 
                            class="caption d-flex align-center mb-12">
                            <v-icon small>mdi-account-multiple-outline</v-icon>
                            
                            <span
                              class="ml-1">
                              Total data abdi dalem
                            </span>
                          </div>
                        </div>

                        <v-spacer />

                        <div>
                          <v-img 
                            width="60"
                            height="60"
                            alt="amanata" 
                            :src="require(`@/assets/image/time/${isDay}.png`)"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  color="white">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </div>
                      </div>

                      <div class="d-flex align-center">
                        <div class="d-flex align-end">
                          <span 
                            class="text-h3 black--text font-weight-bold">
                            {{ count.total_pegawai | numeric }}
                          </span>
                        </div>

                        <v-spacer />

                        <div class="black--text">
                          <div v-if="clock.time.length > 0">
                            <div 
                              class="caption" 
                              style="opacity: 60%;">
                              {{ clock.date | date }}
                            </div>

                            <div 
                              class="body-1 font-weight-bold">
                              {{ clock.time }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </v-skeleton-loader>
            </v-col>
            
            <v-col 
              cols="12" 
              md="4">
              <v-skeleton-loader
                v-for="(item, index) in process.load ? 1 : 1"
                :key="index"
                class="ma-auto"
                :loading="process.load"
                type="image">
                <div>
                  <v-card v-if="!process.load && Object.keys(count).length > 0"
                    flat
                    min-height="175"
                    class="border-radius"
                    color="#FFFFFF">
                    <v-card-text
                      class="pb-1">
                      <div
                        class="d-flex align-start">
                        <div>
                          <v-avatar
                            tile
                            size="50"
                            :color="set_color_rgb"
                            style="border-radius: 15px !important;">
                            <v-icon size="30" :color="set_color">mdi-account-multiple-check-outline</v-icon>
                          </v-avatar>
                        </div>

                        <v-spacer />

                        <div>
                          <span
                            class="mr-1">
                            Lihat
                          </span>
                          
                          <router-link
                            to="/officer?act=AKTIF">
                            <v-icon>mdi-dots-vertical</v-icon>
                          </router-link>
                        </div>
                      </div>
                    </v-card-text>

                    <v-card-text>
                      <div
                        class="body-2 mb-3">
                        Masih Aktif
                      </div>

                      <div
                        class="text-h4 font-weight-bold black--text">
                        {{ count.total_active | numeric }}
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </v-skeleton-loader>
            </v-col>

            <v-col 
              cols="12" 
              md="4">
              <v-skeleton-loader
                v-for="(item, index) in process.load ? 1 : 1"
                :key="index"
                class="ma-auto"
                :loading="process.load"
                type="image">
                <div>
                  <v-card v-if="!process.load && Object.keys(count).length > 0"
                    flat
                    min-height="175"
                    class="border-radius"
                    color="#FFFFFF">
                    <v-card-text
                      class="pb-1">
                      <div
                        class="d-flex align-start">
                        <div>
                          <v-avatar
                            tile
                            size="50"
                            :color="set_color_rgb"
                            style="border-radius: 15px !important;">
                            <v-icon size="30" :color="set_color">mdi-account-multiple-remove-outline</v-icon>
                          </v-avatar>
                        </div>

                        <v-spacer />

                        <div>
                          <span
                            class="mr-1">
                            Lihat
                          </span>
                          
                          <router-link
                            to="/officer?act=TIDAK AKTIF">
                            <v-icon>mdi-dots-vertical</v-icon>
                          </router-link>
                        </div>
                      </div>
                    </v-card-text>

                    <v-card-text>
                      <div
                        class="body-2 mb-3">
                        Sudah Tidak Aktif
                      </div>

                      <div
                        class="text-h4 font-weight-bold black--text">
                        {{ count.total_not_active | numeric }}
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </v-skeleton-loader>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12">
              <v-card
                flat
                color="#f9f9f9"
                class="border-radius">
                <v-card-title 
                  class="body-1 font-weight-bold black--text">
                  Grafik Kalenggahan
                </v-card-title>

                <v-card-subtitle 
                  class="caption pb-0 d-flex align-center">
                  <v-icon small>mdi-chart-bar</v-icon>
                  
                  <span
                    class="ml-1">
                    Sampai Dengan <b>{{ clock.date | date }}</b>
                  </span>
                </v-card-subtitle>

                <v-card-text
                  class="pr-2"
                  :class="process.grafict_kalenggahan ? 'pa-4' : 'pa-0'">
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.grafict_kalenggahan"
                    type="image">
                    <div>
                      <div v-if="!process.grafict_kalenggahan && Object.keys(bar).length > 0">
                        <apexchart 
                          height="500" 
                          :options="bar.chartOptions" 
                          :series="bar.series">
                        </apexchart>
                      </div>
                    </div>
                  </v-skeleton-loader>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12">
              <v-card
                flat
                color="#f9f9f9"
                class="border-radius">
                <v-card-title 
                  class="body-1 font-weight-bold black--text">
                  Grafik Kategori
                </v-card-title>

                <v-card-subtitle 
                  class="caption pb-0 d-flex align-center">
                  <v-icon small>mdi-chart-bar</v-icon>
                  
                  <span
                    class="ml-1">
                    Sampai Dengan <b>{{ clock.date | date }}</b>
                  </span>
                </v-card-subtitle>

                <v-card-text
                  class="pr-2"
                  :class="process.load ? 'pa-4' : 'pa-0'">
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.load"
                    type="image">
                    <div>
                      <div v-if="!process.load && Object.keys(bar_category).length > 0">
                        <apexchart 
                          height="500" 
                          :options="bar_category.chartOptions" 
                          :series="bar_category.series">
                        </apexchart>
                      </div>
                    </div>
                  </v-skeleton-loader>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="6">
              <v-skeleton-loader
                v-for="(item, index) in process.load ? 1 : 1"
                :key="index"
                class="ma-auto"
                :loading="process.load"
                type="image">
                <div>
                  <v-card v-if="!process.load && Object.keys(count).length > 0"
                    flat
                    min-height="175"
                    class="border-radius"
                    color="#FFFFFF">
                    <v-card-text>
                      <apexchart
                        :options="pie.kalenggahan"
                        :series="pie.kalenggahan_data">
                      </apexchart>
                    </v-card-text>
                  </v-card>
                </div>
              </v-skeleton-loader>
            </v-col>

            <v-col
              cols="12"
              md="6">
              <v-skeleton-loader
                v-for="(item, index) in process.load ? 1 : 1"
                :key="index"
                class="ma-auto"
                :loading="process.load"
                type="image">
                <div>
                  <v-card v-if="!process.load && Object.keys(count).length > 0"
                    flat
                    min-height="175"
                    class="border-radius"
                    color="#FFFFFF">
                    <v-card-text>
                      <apexchart
                        :options="pie.gender"
                        :series="pie.gender_data">
                      </apexchart>
                    </v-card-text>
                  </v-card>
                </div>
              </v-skeleton-loader>
            </v-col>
          </v-row>
        </v-col>

        <v-col 
          cols="12" 
          md="3"
          class="py-0">
          <v-card
            flat
            :color="`${set_color_rgb_soft}`"
            class="border-radius"
            min-height="calc(250vh - 655px)">
            <v-card-text>
              <div
                class="body-1 font-weight-bold black--text mb-1">
                Data Urusan
              </div>

              <div
                class="body-2 mb-4">
                Berikut data Urusan:
              </div>

              <v-list
                color="transparent">
                <v-skeleton-loader
                  v-for="(item, index) in process.load ? 5 : urusan"
                  :key="index"
                  class="ma-auto"
                  :loading="process.load"
                  type="list-item-avatar-two-line">
                  <div>
                    <v-list-item v-if="!process.load && urusan.length > 0"
                      class="pa-0 mb-2">
                      <v-list-item-avatar
                        tile
                        size="45"
                        :color="set_color_rgb"
                        class="mr-3"
                        style="border-radius: 15px !important;">
                        <v-icon
                          :color="set_color">
                          mdi-asterisk-circle-outline
                        </v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title
                          class="body-2 font-weight-bold black--text text-capitalize mb-1"
                          style="opacity: 80%;">
                          {{ item.urusan.length > 0 ? item.urusan : 'Tidak Diketahui' }}
                        </v-list-item-title>

                        <v-list-item-subtitle
                          class="caption black--text"
                          style="opacity: 60%;">
                          Jumlah {{ item.total_pegawai | number }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-skeleton-loader>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </section>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        clock: {
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          time: ''
        },
        count: {
        },
        urusan: [],
        pie: {
          kalenggahan_data: [],
          kalenggahan: {},
          gender_data: [],
          gender: {}
        },
        bar: {},
        bar_category: {},
        process: {
          load: false,
          grafict_gender: false,
          grafict_urusan: false,
          grafict_kalenggahan: false
        }
      }
    },
    components: {
      
    },
    computed: {
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      }
    },
    watch: {
      
    },
    mounted () {
      setInterval(this.updateTime, 1000)

      this.fetchUnit()
      // this.fetchTotal()
      // this.fetchGrafictGender()
      // this.fetchGrafictUrusan()
      this.fetchGraficrKalenggahan()
    },
    methods: {
      async fetchUnit () {
        this.process.load = true

        await get('admin/unit')
        .then(response => {
          let res = response.data

          // this.process.load = false
            
          if (res.status === 200) {
            let data = res.results.data

            data.map(obj => {
              if (parseInt(obj.parent_id) === 0 || parseInt(obj.parent_id) === 1) {
                this.urusan.push({
                  total_pegawai: obj.total_pegawai,
                  urusan: obj.name
                })
              }
            })

            this.urusan.reverse()

            this.fetchTotal()
          }
        })
      },

      async fetchTotal () {
        // this.process.load = true

        await get(`admin/dashboard/total`)
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.count = res.results.data
            // this.urusan = res.results.data.urusan

            let data_urusan = res.results.data.urusan
            data_urusan.map(obj => {
              this.urusan.push({
                total_pegawai: obj.total_pegawai,
                urusan: obj.urusan
              })
            })

            this.pie.kalenggahan_data = [parseInt(res.results.data.total_abdi_dalem), parseInt(res.results.data.total_sentana)]

            this.pie.kalenggahan = {
              chart: {
                type: 'donut',
              },
              title: {
                text: 'Kategori',
                align: 'left',
                style: {
                  fontSize: '18px',
                  fontWeight: 'bold',
                  color: 'black'
                }
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      total: {
                        show: true,
                        label: 'Total',
                        fontSize: '24px',
                        fontWeight: 'bold',
                        color: 'black'
                      }
                    }
                  }
                }
              },
              colors: [
                '#009688FF',
                '#607D8BFF'
              ],
              noData: {
                text: this.loading ? 'Loading...' : 'No Data'
              },
              labels: [
                'Abdi Dalem',
                'Sentana'
              ]
            }

            this.pie.gender_data = [parseInt(res.results.data.total_laki_laki), parseInt(res.results.data.total_perempuan)]

            this.pie.gender = {
              chart: {
                type: 'donut',
              },
              title: {
                text: 'Jenis Kelamin',
                align: 'left',
                style: {
                  fontSize: '18px',
                  fontWeight: 'bold',
                  color: 'black'
                },
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      total: {
                        show: true,
                        label: 'Total',
                        fontSize: '24px',
                        fontWeight: 'bold',
                        color: 'black'
                      }
                    }
                  }
                }
              },
              colors: [
                '#880E4FFF',
                '#E91E63FF'
              ],
              noData: {
                text: this.loading ? 'Loading...' : 'No Data'
              },
              labels: [
                'LAKI-LAKI',
                'PEREMPUAN'
              ]
            }

            let data = res.results.data.task_category,
                data_series = [],
                data_colors = [],
                data_categories = []
            
            data.map(obj => {
              data_series.push(parseInt(obj.total_task))
              data_categories.push(obj.category)
              data_colors.push(this.random_rgba())
            })

            this.bar_category = {
              series: [{
                data: data_series
              }],
              chartOptions: {
                chart: {
                  animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  },
                  type: 'bar',
                  events: {
                    click: function(chart, w, e) {
                      // console.log(chart, w, e)
                    }
                  }
                },
                dataLabels: {
                  enabled: true,
                  formatter: function (val) {
                    return val
                  },
                  offsetY: -20,
                  style: {
                    colors: data_colors,
                    fontSize: '12px'
                  }
                },
                colors: data_colors,
                plotOptions: {
                  bar: {
                    columnWidth: '12%',
                    distributed: true,
                    dataLabels: {
                      position: 'top', // top, center, bottom
                    }
                  }
                },
                legend: {
                  show: true
                },
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return Math.round(value)
                    }
                  }
                },
                xaxis: {
                  categories: data_categories,
                  labels: {
                    show: false,
                    style: {
                      colors: data_colors,
                      fontSize: '12px'
                    }
                  }
                }
              }
            }
          }
        })
      },
      updateTime () {
        let cd = new Date()

        this.clock.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2)
      },
      zeroPadding (num, digit) {
        let zero = ''

        for(let i = 0; i < digit; i++) {
          zero += '0'
        }
        return (zero + num).slice(-digit)
      },

      async fetchGrafictGender () {
        this.process.grafict_gender = true

        await get(`admin/dashboard/grafik_gender`)
        .then(response => {
          let res = response.data

          this.process.grafict_gender = false

          if (res.status === 200) {
            
          }
        })
      },

      async fetchGrafictUrusan () {
        this.process.grafict_urusan = true

        await get(`admin/dashboard/grafik_urusan`)
        .then(response => {
          let res = response.data

          this.process.grafict_urusan = false

          if (res.status === 200) {
            
          }
        })
      },

      random_rgba () {
        let letters = '0123456789ABCDEF'
        let color = '#'

        for (let i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)]
        }
        return color
      },

      async fetchGraficrKalenggahan () {
        this.process.grafict_kalenggahan = true

        await get(`admin/dashboard/grafik_kalenggahan`)
        .then(response => {
          let res = response.data

          this.process.grafict_kalenggahan = false

          if (res.status === 200) {
            let data = res.results.data,
                data_series = [],
                data_colors = [],
                data_categories = []

            data.map(obj => {
              data_series.push(parseInt(obj.total))
              data_categories.push(obj.user_kalenggahan)
              data_colors.push(this.random_rgba())
            })

            this.bar = {
              series: [{
                data: data_series
              }],
              chartOptions: {
                chart: {
                  animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  },
                  type: 'bar',
                  events: {
                    click: function(chart, w, e) {
                      // console.log(chart, w, e)
                    }
                  }
                },
                dataLabels: {
                  enabled: true,
                  formatter: function (val) {
                    return val
                  },
                  offsetY: -20,
                  style: {
                    colors: data_colors,
                    fontSize: '12px'
                  }
                },
                colors: data_colors,
                plotOptions: {
                  bar: {
                    columnWidth: '100%',
                    distributed: true,
                    dataLabels: {
                      position: 'top', // top, center, bottom
                    }
                  }
                },
                legend: {
                  show: true
                },
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return Math.round(value)
                    }
                  }
                },
                xaxis: {
                  categories: data_categories,
                  labels: {
                    show: false,
                    style: {
                      colors: data_colors,
                      fontSize: '12px'
                    }
                  }
                }
              }
            }
          }
        })
      }
    }
  }
</script>